<template>
    <div>
        <!-- <v-card class="mb-4 mt-0" elevation="0"> -->
            <!-- <v-card-text> -->
                <v-row>
                    <v-col class="py-2">
                        <datePickerForm
                            label="Fecha de captura"
                            :valueInput="values.bill_date_emitted"
                            :rule="rules.bill_date_emitted"
                            @valueChange="(v) => {values.bill_date_emitted = v; delete serverErrors['bill_date_emitted']}"
                            :errorMessages="serverErrors['bill_date_emitted']"
                            :disabled="true"
                        ></datePickerForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                        <autocompleteOneForm
                            label="Tipo de cuenta"
                            :valueInput="values.type"
                            :rule="rules.type"
                            :items="items.types"
                            :errorMessages="serverErrors.type"
                            @valueChange="(v) => {values.type = v; delete serverErrors.type}"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>
                
                <!-- <v-row>
                    <v-col class="py-2">
                        <datePickerForm
                            label="Fecha de vencimiento"
                            :valueInput="values.due_date"
                            :rule="rules.due_date"
                            @valueChange="(v) => {values.due_date = v; delete serverErrors['due_date']}"
                            :errorMessages="serverErrors['due_date']"
                        ></datePickerForm>
                    </v-col>
                </v-row> -->
                
                <v-row>
                    <v-col class="py-2">
                        <!-- <div> -->
                            <autocompleteOneForm
                                label="Proveedor"
                                :loading="loadingProvider"
                                :valueInput="values.provider_id"
                                :rule="rules.provider_id"
                                :items="serverItems.providers"
                                :errorMessages="serverErrors.provider_id"
                                @valueChange="(v) => {values.provider_id = v; getSelectedProvider(v); delete serverErrors.provider_id;}"
                            ></autocompleteOneForm>
                            
                        <!-- </div> -->

                    </v-col>
                    <iconButton v-if="supplier.slug" :class="`mt-2 mr-3`" :props="openProviderModalBtn"></iconButton>
                  
                </v-row>
               
                

                <v-row>
                    <v-col class="py-2">
                        <autocompleteOneForm
                            label="Vencimiento"
                            :valueInput="values.credit_period"
                            :rule="rulesCreditPeriod"
                            :items="items.credit_period"
                            :disabled="lockCreditPeriod"
                            :errorMessages="serverErrors.credit_period"
                            @valueChange="(v) => {values.credit_period = v; delete serverErrors.credit_period}"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                        <autocompleteOneForm
                            label="OT"
                            :loading="loadingReferences"
                            :valueInput="values.reference_id"
                            :rule="rules.reference_id"
                            :items="serverItems.references"
                            :errorMessages="serverErrors.reference_id"
                            @valueChange="(v) => {values.reference_id = v; delete serverErrors.reference_id}"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                       <textFieldForm 
                            @valueChange="(v) => {values.folio = v; delete serverErrors.folio}" 
                            :valueInput="values.folio" 
                            :rule="rules.folio" 
                            label="Folio"
                            :errorMessages="serverErrors.folio"
                        ></textFieldForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                        <fileInputForm
                            
                            label="Factura XML"
                            :multiple="false"
                            :valueInput="file"
                            
                            :accept="'text/xml'"
                            @valueChange="(v) => {this.readXML(v)}"
                            :errorMessages="serverErrors.photo_file"
                            @cleared:file="clearInputs"
                        ></fileInputForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                        <datePickerForm
                            label="Fecha de facturación"
                            :valueInput="values.billing_date"
                            :rule="rules.required"
                            @valueChange="(v) => {values.billing_date = v; delete serverErrors['billing_date']}"
                            :errorMessages="serverErrors['billing_date']"
                            :disabled="xml === 1"
                        ></datePickerForm>
                    </v-col>

                    <v-col class="py-2">
                        <autocompleteOneForm
                            label="Método de pago"
                            :valueInput="values.payment_method"
                            :rule="rules.required"
                            :items="items.payment_methods"
                            :disabled="xml === 1"
                            :errorMessages="serverErrors.payment_method"
                            @valueChange="(v) => {values.payment_method = v; delete serverErrors.payment_method}"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>


                <v-row>
                    <v-col class="py-2">
                        <textFieldForm 
                            @valueChange="(v) => {values.subtotal = v; this.total();delete serverErrors.subtotal}" 
                            :valueInput="values.subtotal" 
                            :rule="rules.amount" 
                            label="Subtotal"
                            :errorMessages="serverErrors.subtotal"
                            :prefix="values.subtotal === '' ? '' : '$'"
                        ></textFieldForm>
                    </v-col>
                    <v-col class="py-2">
                        <textFieldForm 
                            @valueChange="(v) => {values.total = v;delete serverErrors.total}" 
                            :valueInput="values.total" 
                            :rule="[]" 
                            label="Total"
                            :errorMessages="serverErrors.total"
                            :prefix="values.total === '' ? '' : '$'"
                            :disabled="true"
                        ></textFieldForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                        <textFieldForm 
                            @valueChange="(v) => {values.discounts = v; this.total();delete serverErrors.discounts}" 
                            :valueInput="values.discounts" 
                            :rule="rules.amount" 
                            label="Descuentos"
                            :errorMessages="serverErrors.discounts"
                            :prefix="values.discounts === '' ? '' : '$'"
                            :disabled="xml === 1"
                        ></textFieldForm>
                    </v-col>
                    <v-col class="py-2">
                        <textFieldForm 
                            @valueChange="(v) => {values.ieps = v; this.total();delete serverErrors.ieps}" 
                            :valueInput="values.ieps" 
                            :rule="rules.amount" 
                            label="IEPS"
                            :errorMessages="serverErrors.ieps"
                            :prefix="values.ieps === '' ? '' : '$'"
                            :disabled="xml === 1"
                        ></textFieldForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                        <textFieldForm 
                            @valueChange="(v) => {values.iva = v; this.total();delete serverErrors.iva}" 
                            :valueInput="values.iva" 
                            :rule="rules.amount" 
                            label="IVA"
                            :errorMessages="serverErrors.iva"
                            :prefix="values.iva === '' ? '' : '$'"
                            :disabled="xml === 1"
                        ></textFieldForm>
                    </v-col>
                    <v-col class="py-2">
                        <textFieldForm 
                            @valueChange="(v) => {values.isr_withholdings = v; this.total();delete serverErrors.isr_withholdings}" 
                            :valueInput="values.isr_withholdings" 
                            :rule="rules.amount" 
                            label="Retenciones ISR"
                            :errorMessages="serverErrors.isr_withholdings"
                            :prefix="values.isr_withholdings === '' ? '' : '$'"
                            :disabled="xml === 1"
                        ></textFieldForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                        <textFieldForm 
                            @valueChange="(v) => {values.iva_withholdings = v; this.total();delete serverErrors.iva_withholdings}" 
                            :valueInput="values.iva_withholdings" 
                            :rule="rules.amount" 
                            label="Retenciones IVA"
                            :errorMessages="serverErrors.iva_withholdings"
                            :prefix="values.iva_withholdings === '' ? '' : '$'"
                            :disabled="xml === 1"
                        ></textFieldForm>
                    </v-col>

                    <v-col class="py-2">
                        <textFieldForm 
                            @valueChange="(v) => {values.ish = v; this.total();delete serverErrors.ish}" 
                            :valueInput="values.ish" 
                            :rule="rules.amount" 
                            label="ISH"
                            :errorMessages="serverErrors.ish"
                            :prefix="values.ish === '' ? '' : '$'"
                            :disabled="xml === 1"
                        ></textFieldForm>
                    </v-col>


                   
                </v-row>
<!-- 
                <v-row>
                    <v-col class="py-2">
                        <textFieldForm 
                            @valueChange="(v) => {values.current_mxn_per_usd = v; this.total();delete serverErrors.current_mxn_per_usd}" 
                            :valueInput="values.current_mxn_per_usd" 
                            :rule="rules.current_mxn_per_usd" 
                            label="Tipo de cambio"
                            :errorMessages="serverErrors.current_mxn_per_usd"
                            :prefix="values.current_mxn_per_usd === '' ? '' : '$'"
                        ></textFieldForm>
                    </v-col>
                </v-row> -->

                <v-row>
                    <v-col class="py-2">
                        <textFieldForm 
                            @valueChange="(v) => {values.uuid = v; this.total();delete serverErrors.uuid}" 
                            :valueInput="values.uuid" 
                            :rule="[]" 
                            label="UUID"
                            :errorMessages="serverErrors.uuid"
                            :disabled="xml === 1"
                        ></textFieldForm>
                    </v-col>
                     <v-col class="py-2">
                        <autocompleteOneForm
                            label="Divisa"
                            :valueInput="values.currency"
                            :rule="rules.currency"
                            :items="items.currency"
                            :errorMessages="serverErrors.currency"
                            @valueChange="(v) => {values.currency = v; delete serverErrors.currency}"
                            :disabled="xml === 1"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>


               

                <v-row>
                    <v-col class="py-2">
                        <autocompleteOneForm
                            :loading="loadingConcepts"
                            label="Cuenta"
                            :valueInput="values.concept_id"
                            :rule="rules.concept_id"
                            :items="serverItems.concepts"
                            :errorMessages="serverErrors.concept_id"
                            @valueChange="(v) => {values.concept_id = v; delete serverErrors.concept_id}"
                        ></autocompleteOneForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                        <textFieldForm 
                            @valueChange="(v) => {values.comments = v; this.total();delete serverErrors.comments}" 
                            :valueInput="values.comments" 
                            :rule="[]" 
                            label="Concepto"
                            :errorMessages="serverErrors.comments"
                            
                        ></textFieldForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-2">
                        <fileInputForm
                            :accept="'.pdf,.PDF'"
                            label="Factura adjunta (pdf)"
                            :multiple="false"
                            :valueInput="values.invoice_pdf_file"
                            :url="values.invoice_pdf_path"
                            :rule="[]"
                            @valueChange="(v) => {values.invoice_pdf_file = v; delete serverErrors.invoice_pdf_file}"
                            :errorMessages="serverErrors.invoice_pdf_file"
                            v-on:update:url="values.invoice_pdf_path = $event"
                        ></fileInputForm>
                    </v-col>
                </v-row>

                
                
                
            <!-- </v-card-text> -->
        <!-- </v-card> -->
        <!-- MODAL - SUPPLIER FILES -->
        <modal :props="modalProps" @modalResponse="method_handler">
             <!-- body -->
            
            <template slot="cardBody">
                <div class="my-2">
                    <v-row>
                        <v-col class="py-2">
                            <fileInputForm
                                :accept="'.jpg,.jpeg,.JPG,.PNG,.png,.pdf,.PDF'"
                                label="Constancia situación fiscal"
                                :multiple="false"
                                :valueInput="supplier.fiscal_situation_certificate_file"
                                :url="supplier.fiscal_situation_certificate_url"
                                :rule="[]"
                                @valueChange="(v) => {supplier.fiscal_situation_certificate_file = v; delete serverErrors.fiscal_situation_certificate_file}"
                                :errorMessages="serverErrors.fiscal_situation_certificate_file"
                                v-on:update:url="supplier.fiscal_situation_certificate_path = supplier.fiscal_situation_certificate_url = $event"
                            ></fileInputForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col class="py-2">
                            <fileInputForm
                                :accept="'.jpg,.jpeg,.JPG,.PNG,.png,.pdf,.PDF'"
                                label="Datos bancarios"
                                :multiple="false"
                                :valueInput="supplier.bank_details_file"
                                :url="supplier.bank_details_url"
                                :rule="[]"
                                @valueChange="(v) => {supplier.bank_details_file = v; delete serverErrors.bank_details_file}"
                                :errorMessages="serverErrors.bank_details_file"
                                v-on:update:url="supplier.bank_details_path = supplier.bank_details_url =$event"
                            ></fileInputForm>
                        </v-col>
                    </v-row>
                </div>

            </template>
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end">
					<v-col cols="12" sm="4">
						<secondaryButton
						:props="cancelModal"
						></secondaryButton>
					</v-col>
					<v-col cols="12" sm="4">
						<primaryButton
						:props="acceptModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template> 
		</modal>
		

    </div>
</template>

<script>
import Object2Form from '../../helpers/Object2Form'

/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'edit'],
   
    data(){
        return {
            supplier:{},
            loadingSelectedProvider: false,
            loadingProvider: false,
            loadingReferences: false,
            loadingConcepts: false,
            lockCreditPeriod: false,
            rulesCreditPeriod: [],
            file: [],
            xml: 0,
            modalProps: {
				visible: false,
				width: '500',
				title: '',
				text: '',
				loading: false,
				bottomLineColor: 'primary',
				
			},
			
			cancelModal: {
                text: "Cerrar",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalProps.visible = false}
            },
			acceptModal: {
                text: "Guardar",
                icon: "",
				to: "",
				block: true,
				color: 'primary',
				textColor:'black',
                textColorLevel: '0',
				loading:false,
                click: ()=>{this.uploadSupplierFiles()}
            },
            openProviderModalBtn: {
                hasTooltip:true,
                tooltip: 'Archivos',
                color:'grey lighten-3',
                iconColor:'grey darken-3',
                height:'39',
                icon: "mdi-file-document-multiple-outline",
				to: "",
				block: false,
                loading:false,
                click: ()=>{this.openModalProvider()}
            },
            
            rules: {
                
				required: [
                    v => !!v || 'El campo es requerido'
				],
                requiredFile: [
                    v => (v instanceof File) || 'El campo es requerido'
                ],
				bill_date_emitted: [
					v => !!v || 'El campo requerido'
				],
				provider_id: [
                    v => !!v || 'El campo es requerido'
				],
                type: [
                    v => !!v || 'El campo es requerido'
                ],
                reference_id: [
                    v => !!v || 'El campo es requerido'
                ],
                folio: [
                    v => !!v || 'El campo es requerido'
                ],
                current_mxn_per_usd: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,2})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido';
                        if(v === 0 || v === '0' || v<=0)
                            return 'El campo debe ser máyor a 1';
                        return true;
                    }
                ],
                amount: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,2})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido'
                        return true;
                    }
                ],
                currency: [
                    v => !!v || 'El campo es requerido'
                ],
                credit_period: [
                    v => !!v || 'El campo es requerido'
                ],
                concept_id: [
                    v => !!v || 'El campo es requerido'
                ]
				
            },
            items:{
                types:[ 
                    {text: "CONTADO", value: "CONTADO"},
                    {text: "CRÉDITO", value: "CRÉDITO"},
                    {text: "ANTICIPO", value: "ANTICIPADA"},
                    {text: "COMPROBANTES", value: "COMPROBANTES"},
                    // {text: "PAGO PROVEEDOR", value: "COTIZACIÓN"},
                    // {text: "SERVICIOS", value: "SERVICIOS"},
                ],
                currency: [
                    {text: "MXN", value: "MXN"},
                    {text: "USD", value: "USD"}
                ],
                payment_methods: [
                    {text: "PUE", value: "PUE"},
                    {text: "PPD", value: "PPD"}
                ],
                credit_period:[
                    { text: "1 DÍA", value: 1 },
                    { text: "2 DÍAS", value: 2 },
                    { text: "3 DÍAS", value: 3 },
                    { text: "4 DÍAS", value: 4 },
                    { text: "5 DÍAS", value: 5 },
                    { text: "6 DÍAS", value: 6 },
                    { text: "7 DÍAS", value: 7 },
                    { text: "8 DÍAS", value: 8 },
                    { text: "9 DÍAS", value: 9 },
                    { text: "10 DÍAS", value: 10 },
                    { text: "11 DÍAS", value: 11 },
                    { text: "12 DÍAS", value: 12 },
                    { text: "13 DÍAS", value: 13 },
                    { text: "14 DÍAS", value: 14 },
                    { text: "15 DÍAS", value: 15 },
                    { text: "16 DÍAS", value: 16 },
                    { text: "17 DÍAS", value: 17 },
                    { text: "18 DÍAS", value: 18 },
                    { text: "19 DÍAS", value: 19 },
                    { text: "20 DÍAS", value: 20 },
                    { text: "21 DÍAS", value: 21 },
                    { text: "22 DÍAS", value: 22 },
                    { text: "23 DÍAS", value: 23 },
                    { text: "24 DÍAS", value: 24 },
                    { text: "25 DÍAS", value: 25 },
                    { text: "26 DÍAS", value: 26 },
                    { text: "27 DÍAS", value: 27 },
                    { text: "28 DÍAS", value: 28 },
                    { text: "29 DÍAS", value: 29 },
                    { text: "30 DÍAS", value: 30 },
                    { text: "31 DÍAS", value: 31 },
                    { text: "32 DÍAS", value: 32 },
                    { text: "33 DÍAS", value: 33 },
                    { text: "34 DÍAS", value: 34 },
                    { text: "35 DÍAS", value: 35 },
                    { text: "36 DÍAS", value: 36 },
                    { text: "37 DÍAS", value: 37 },
                    { text: "38 DÍAS", value: 38 },
                    { text: "39 DÍAS", value: 39 },
                    { text: "40 DÍAS", value: 40 },
                    { text: "41 DÍAS", value: 41 },
                    { text: "42 DÍAS", value: 42 },
                    { text: "43 DÍAS", value: 43 },
                    { text: "44 DÍAS", value: 44 },
                    { text: "45 DÍAS", value: 45 },
                    { text: "46 DÍAS", value: 46 },
                    { text: "47 DÍAS", value: 47 },
                    { text: "48 DÍAS", value: 48 },
                    { text: "49 DÍAS", value: 49 },
                    { text: "50 DÍAS", value: 50 },
                    { text: "51 DÍAS", value: 51 },
                    { text: "52 DÍAS", value: 52 },
                    { text: "53 DÍAS", value: 53 },
                    { text: "54 DÍAS", value: 54 },
                    { text: "55 DÍAS", value: 55 },
                    { text: "56 DÍAS", value: 56 },
                    { text: "57 DÍAS", value: 57 },
                    { text: "58 DÍAS", value: 58 },
                    { text: "59 DÍAS", value: 59 },
                    { text: "60 DÍAS", value: 60 },
                    { text: "61 DÍAS", value: 61 },
                    { text: "62 DÍAS", value: 62 },
                    { text: "63 DÍAS", value: 63 },
                    { text: "64 DÍAS", value: 64 },
                    { text: "65 DÍAS", value: 65 },
                    { text: "66 DÍAS", value: 66 },
                    { text: "67 DÍAS", value: 67 },
                    { text: "68 DÍAS", value: 68 },
                    { text: "69 DÍAS", value: 69 },
                    { text: "70 DÍAS", value: 70 },
                    { text: "71 DÍAS", value: 71 },
                    { text: "72 DÍAS", value: 72 },
                    { text: "73 DÍAS", value: 73 },
                    { text: "74 DÍAS", value: 74 },
                    { text: "75 DÍAS", value: 75 },
                    { text: "76 DÍAS", value: 76 },
                    { text: "77 DÍAS", value: 77 },
                    { text: "78 DÍAS", value: 78 },
                    { text: "79 DÍAS", value: 79 },
                    { text: "80 DÍAS", value: 80 },
                    { text: "81 DÍAS", value: 81 },
                    { text: "82 DÍAS", value: 82 },
                    { text: "83 DÍAS", value: 83 },
                    { text: "84 DÍAS", value: 84 },
                    { text: "85 DÍAS", value: 85 },
                    { text: "86 DÍAS", value: 86 },
                    { text: "87 DÍAS", value: 87 },
                    { text: "88 DÍAS", value: 88 },
                    { text: "89 DÍAS", value: 89 },
                    { text: "90 DÍAS", value: 90 }
                ]
            },
            serverItems: {
                providers: [],
                references: [],
                concepts: []
            },

          
        }
    },
    watch: {
        values: function (vv) {
            //console.log(this.values, vv);
        },
        [`values.type`]: function (value) {
            this.checkCreditDaysInput(value);
            
        }
    },
    mounted(){
        this.getProviders();
        this.getReferences();
        this.getConcepts();
        this.checkCreditDaysInput(this.values.type);
        this.getSelectedProvider(this.values.provider_id)
        //this.getExchange();
        if(!this.edit){
            console.log();
            this.values.bill_date_emitted = new Date().toJSON().slice(0,10);
        }
    },
    methods: {

        method_handler(object){
            console.log(object);
			this[object.methodName](object.parameters)
		},

        openModalProvider()
        {
            if(this.supplier?.slug == null)
                return;
            // this.acceptModal.text = "SI, ELIMINAR";
            // this.cancelModal.text = "No, cancelar";
            // this.acceptModal.click = this.delete;
            // this.acceptModal.color = 'error';
			// this.selectedID = parameters.id;
			this.modalProps = {
				...this.modalProps,
				text: ``,
                title: this.supplier.name,
			}
			this.modalProps.visible = true;
        },
        prepareSupplierRequest(request)
        {
            let data = {
                fiscal_situation_certificate_file: [],
                fiscal_situation_certificate_path: request.fiscal_situation_certificate_path,
                bank_details_file: [],
                bank_details_path: request.bank_details_path,
            }


            data.fiscal_situation_certificate_file = request.fiscal_situation_certificate_file;

            if(request.fiscal_situation_certificate_path == '' && (request.fiscal_situation_certificate_file instanceof Array))
                data.fiscal_situation_certificate_file = null;

            if(request.fiscal_situation_certificate_path != '' && (request.fiscal_situation_certificate_file instanceof Array))
                delete data.fiscal_situation_certificate_file;

            data.bank_details_file = request.bank_details_file;

            if(request.bank_details_path == '' && (request.bank_details_file instanceof Array))
                data.bank_details_file = null;

            if(request.bank_details_path != '' && (request.bank_details_file instanceof Array))
                delete data.bank_details_file;

            data._method= 'PUT';

            
            return Object2Form.objectToFormData(data, '', []);
        },

        uploadSupplierFiles()
        {
            const request = this.prepareSupplierRequest(this.supplier);
            this.acceptModal.loading = true;
            this.$api.supplier.updateFiles(this.$store.state.business,this.supplier.slug, request)
				.then((resp) =>{
					this.modalProps.visible = false;
                    this.getSelectedProvider(this.supplier.slug);
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.acceptModal.loading = false;
				})
			;
        },

        checkCreditDaysInput(value)
        {
            this.lockCreditPeriod = false;
            this.rulesCreditPeriod = this.rules.credit_period;
            if(value == "CONTADO"){
                this.rulesCreditPeriod = [];
                this.lockCreditPeriod = true;
                this.values.credit_period = "";
            }
        },

        getExchange()
        {
            this.$api.utils.getExchange()
                .then((resp) => {
                    this.values.current_mxn_per_usd =  parseFloat(resp.data.usd_to_mxn).toFixed(2);
                })
                .catch((error) => {
                    console.log(error);
                    this.values.current_mxn_per_usd = '';
                })
            ;
        },

        getSelectedProvider(value = "")
        {
            if(value == null || value == '')
                return;


            this.loadingSelectedProvider = true;
            this.openProviderModalBtn.loading = true;
            this.$api.supplier.get(this.$store.state.business,value)
				.then((resp) =>{
					this.supplier = resp.data;
                    this.supplier.fiscal_situation_certificate_file = [];
                    this.supplier.bank_details_file = [];

                    this.openProviderModalBtn.color = "grey lighten-3";
                    if(this.supplier.fiscal_situation_certificate_url != null || this.supplier.bank_details_url != null){
                        this.openProviderModalBtn.color = "primary";
                    }
                    
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingSelectedProvider = false;
                    this.openProviderModalBtn.loading = false;
				})
			;
        },



       
        getProviders()
        {
            this.loadingProvider = true;
            this.$api.supplier.getSelectSuppliers(this.$store.state.business)
				.then((resp) =>{
					//console.log(resp, "desde form");
					this.serverItems.providers = resp.data;
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingProvider = false;
				})
			;
        },

        getReferences()
        {
            this.loadingReferences = true;
            this.$api.reference.getSelectReferences(this.$store.state.business)
                .then((resp) => {
                    this.serverItems.references = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingReferences = false;
                })
            ;
        },

        getConcepts()
        {
            this.loadingConcepts = true;
            this.$api.concept.getSelectConcepts(this.$store.state.business)
                .then((resp) => {
                    this.serverItems.concepts = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingConcepts = false;
                })
            ;
        },

        total() {
            const taxes = ((parseFloat(this.values.iva) + parseFloat(this.values.ieps)) - (parseFloat(this.values.iva_withholdings)  + parseFloat(this.values.isr_withholdings) + parseFloat(this.values.discounts)));
            this.values.total =  parseFloat(this.values.subtotal) + parseFloat(taxes) - parseFloat(this.values.ish);
            delete this.serverErrors.total;
        },

        readXML(file) {
            if (file !== null) {
                let formdata = new FormData();
                formdata.append("xml_archive", file);
                this.$api.balance.readCAXML(formdata)
                .then((response) => {
                    // this.values.taxes = response.data.taxes;
                    this.values.discounts = response.data.discounts;
                    this.values.ieps = response.data.ieps;
                    this.values.iva = response.data.iva;
                    this.values.iva_withholdings = response.data.iva_withholdings;
                    this.values.isr_withholdings = response.data.isr_withholdings;
                    this.values.subtotal = response.data.subtotal;
                    this.values.total = response.data.total;
                    this.values.currency = response.data.currency;
                    this.values.uuid = response.data.uuid;
                    this.values.ish = response.data?.ish??0;
                    this.values.taxes_items = response.data.taxes_items;
                    this.values.payment_method = response.data.payment_method;
                    this.values.billing_date = response.data?.date?.split("T")[0]??'';
                    this.xml = 1;
                })
                .catch((error) => {
                    alert(error);
                });
            }
        },

        clearInputs() {
            this.xml = 0;
            // this.values.taxes = 0;
            this.values.subtotal = 0;
            this.values.total = 0;

            this.values.discounts = 0;
            this.values.ieps = 0;
            this.values.iva = 0;
            this.values.iva_withholdings = 0;
            this.values.isr_withholdings = 0;

            this.values.currency = "";
            this.values.uuid = "";

            console.log(this.values, file)
        },
    }
}
</script>

<style>

</style>